import React from 'react'

const Header = () => {
  return (
    <h1> Expense Tracker</h1>
  )
}

export default Header